<template>
  <div id="scene-container" ref="sceneContainer"></div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

export default {
  name: 'modelAr',
  props: ['src'],
  data () {
    return {
      container: null,
      scene: null,
      camera: null,
      controls: null,
      renderer: null,
      clips: null,
      mixer: null,
      gltf: null,
      clock: null,
    }
  },
  methods: {
    init () {
      // set container
      this.container = this.$refs.sceneContainer
      // add camera
      const sizeBound = new THREE.Vector3(8, 8, 8)
      const fov = 60 // Field of view
      const aspect = this.container.clientWidth / this.container.clientHeight
      const near = 0.1 // the near clipping plane
      const far = 30 // the far clipping plane
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
      camera.position.set(2, 5, 7)
      this.camera = camera
      // create scene
      this.scene = new THREE.Scene()
      this.clock = new THREE.Clock();
      let src = this.src

      let scene = this.scene
				new RGBELoader()
					.setDataType( THREE.UnsignedByteType )
					.setPath( '/dist/assets/front_white/img/models/' )
					.load( 'photo_studio_01_1k.hdr', function ( texture ) {

						const envMap = pmremGenerator.fromEquirectangular( texture ).texture;

						//scene.background = envMap;
						scene.environment = envMap;

						texture.dispose();
						pmremGenerator.dispose();

					} );

      this.renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true} );
      this.renderer.setPixelRatio( window.devicePixelRatio );
      this.renderer.setSize( window.innerWidth, window.innerHeight );
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 0.7;
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.container.appendChild( this.renderer.domElement );
      this.renderer.clearcolor = 0xdddddd;
//      const ambientLight = new THREE.AmbientLight(0xffffff, 1)
//      this.scene.add(ambientLight)

      const directLight = new THREE.DirectionalLight(0xffffff, 0.7)
      const directLight1 = new THREE.DirectionalLight(0xffffff, 0.7)
      directLight.position.set(10,10,10)
      directLight1.position.set(-10,10,-10)
      this.scene.add(directLight,directLight1)

      const pmremGenerator = new THREE.PMREMGenerator( this.renderer );
      //pmremGenerator.compileEquirectangularShader();
      // add controls
      this.controls = new OrbitControls(this.camera, this.container)
      this.controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.PAN
      }
 
      this.container.appendChild(this.renderer.domElement)
      // set aspect ratio to match the new browser window aspect ratio
      this.camera.aspect = this.container.clientWidth / this.container.clientHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)
      const loader = new GLTFLoader()
      loader.load(
        this.src,
        gltf => {
          this.scaleToFit(gltf.scene, sizeBound)
          let b = new THREE.Box3().setFromObject(gltf.scene)
          gltf.scene.position.sub(b.getCenter()) // центрируем
          // gltf.scene.position.y -= (sizeBound.y - b.getSize().y) * 0.5; // опускаем к "полу"
          this.mixer = new THREE.AnimationMixer( gltf.scene );
          let clips = gltf.animations;
          if (clips) {
            clips.forEach( clip => this.playClip( clip ))
          }
          this.scene.add(gltf.scene)
        },
        undefined,
        undefined,
      )
      // this.renderer.setAnimationLoop(() => {
      //   this.animate()
      // })
    },
    playClip (clip) {
      this.mixer.clipAction( clip ).play();
    },
    animate () {
        requestAnimationFrame(this.animate)
        //this.mixer.clipAction( gltf.animations[0] ).play();
        let delta = this.clock.getDelta()
        if (this.mixer) this.mixer.update(delta)
        this.render()
    },
    render () {
      this.renderer.render(this.scene, this.camera)
    },
    scaleToFit (obj, bound) {
      let box = new THREE.Box3().setFromObject(obj)
      let size = new THREE.Vector3()
      box.getSize(size)
      let vScale = new THREE.Vector3().copy(bound).divide(size)
      let scale = Math.min(vScale.x, Math.min(vScale.y, vScale.z))
      obj.scale.setScalar(scale)
    },
  },
  mounted () {
    this.init()
    this.animate()
  },
}
</script>

<style type="text/scss" lang="scss" scoped>
@import './src/front_white/sass/components/settings';

#scene-container {
  width: 900px;
  height: 70vh;
  max-width: 100%;
  max-height: 100%;
  background: linear-gradient(180deg, $white-color-500 0%, $white-color-100 46%, $white-color 50%, $white-color-100 54%, $white-color-500 100%);
}
</style>
